<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <g fill="none" fill-rule="evenodd">
        <g fill="#000">
            <g>
                <path class="fill" d="M58.545 5.498c.08.258.122.526.122.796v46.079c0 1.473-1.194 2.666-2.667 2.666-.27 0-.538-.04-.795-.12l-17.951-5.61c-.645 5.273-5.14 9.358-10.587 9.358C20.776 58.667 16 53.89 16 48v-5.334h-5.333c-4.335 0-7.865-3.447-7.997-7.75l-.003-.25V24c0-4.418 3.581-8 8-8H16L55.205 3.749c1.405-.44 2.901.344 3.34 1.75zM21.333 44.587V48c0 2.946 2.388 5.333 5.334 5.333 2.811 0 5.115-2.175 5.318-4.935L32 47.92l-10.667-3.333zm32-34.667l-32 9.997v18.83l32 9.997V9.92zM16 21.333h-5.333c-1.368 0-2.495 1.03-2.65 2.356L8 24v10.667c0 1.472 1.194 2.666 2.667 2.666H16v-16z" transform="translate(-1074 -431) translate(1074 431)"/>
            </g>
        </g>
    </g>
</svg>
